import FetcherTableSkeleton from "../FetcherTableSkeleton";

/** Placeholder that mirrors DevObjectsTable while the catalogue is loading. */
const DevObjectsSkeleton = () => <FetcherTableSkeleton columns={6} />;

export default DevObjectsSkeleton;
